import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Blocking dialog shown when the Keycloak session has ended server-side
 * (idle/max timeout, logout from another tab, admin revocation). Closing it is
 * the only way out: the caller then clears the app state and redirects to the
 * session-expired page.
 */
@Component({
  selector: 'app-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class SessionExpiredDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<SessionExpiredDialogComponent, 'exit'>) {}

  public exit(): void {
    this.dialogRef.close('exit');
  }
}
